'use client'

import { Flex } from 'antd'
import { getCookie } from 'shared/libs/storage/cookie'

import { Image } from 'shared/ui'
import { Button } from 'shared/ui/button'

import styles from './FooterStoreBanner.module.scss'

const stores = [
  {
    name: 'Google play',
    logo: '/static/svg/google-play.svg',
    link: 'https://play.google.com/store/apps/details?id=com.maanavan.mb_kyrgyzstan&hl=ru',
  },
  {
    name: 'App Store',
    logo: '/static/svg/apple-store.svg',
    link: 'https://apps.apple.com/ru/app/mbank-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%B1%D0%B0%D0%BD%D0%BA/id922922121',
  },
]

export function FooterStoreBanner() {
  const isWebview = getCookie('isWebview') === 'true'

  if (isWebview) return null

  return (
    <div className={styles.banner}>
      <Image
        className={styles.bannerImg}
        src={'/static/png/storeBanner.png'}
        quality={100}
        width={300}
        height={136}
        alt={''}
      />
      <Flex justify="space-between" className={styles.buttons}>
        {stores.map(({ link, logo, name }) => (
          <Button
            key={name}
            variant="additional"
            href={link}
            className={styles.storeButton}
          >
            <Image src={logo} width={20} height={20} alt="" />
            <Flex vertical>
              <span className={styles.storeLabel}>Доступно в</span>
              <span className={styles.storeName}>{name}</span>
            </Flex>
          </Button>
        ))}
      </Flex>
    </div>
  )
}
